import useUser from './useUser';
import { Channel } from '../types';

export function isActiveCustomer(channels?: Pick<Channel, 'state'>[] | null): boolean {
  return channels?.some((ch) => ch.state === 'ACTIVE_CUSTOMER') ?? false;
}

export default function useIsActiveCustomer(): boolean {
  const { data } = useUser();
  return isActiveCustomer(data?.channels);
}
